import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { Alert, Anchor, Flex, Text } from '@mantine/core'

import {
  useQueryGetUserLogged,
  useQueryGetUserSubscription,
  useQueryGetUserTaxProfile,
} from '@flecto/core/shared'
import { useTranslation } from '@flecto/translations'
import { Icon, useNotifications } from '@flecto/ui'
import useMediaQuery from '@flecto/ui/lib/utils/useMediaQuery'
import { Page } from '@flecto/ui/saas'
import { useIntercom } from '@flecto/utils'

import { BillingDetails } from '../components/BillingDetails/BillingDetails'
import { BillingHistory } from '../components/BillingHistory/BillingHistory'
import { NextBilling } from '../components/NextBilling/NextBilling'
import { PaymentMethod } from '../components/PaymentMethod/PaymentMethod'

export function PageBilling() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_billing' })
  const { t: tNotification } = useTranslation('saas', {
    keyPrefix: 'notifications',
  })
  const { isMobile } = useMediaQuery()
  const { data } = useQueryGetUserLogged()
  const { data: taxProfile } = useQueryGetUserTaxProfile()
  const {
    data: userSubscription,
    isError,
    isLoading,
  } = useQueryGetUserSubscription()
  const { showIntercomWithMessage } = useIntercom()

  const { showNotification } = useNotifications()

  if (isError) {
    showNotification({
      message: tNotification('alert_error_general'),
      type: 'error',
    })
  }

  return (
    <Page>
      <Page.Title>{t('page_title')}</Page.Title>
      <Page.Content>
        <Flex direction='column' gap='lg' w='100%'>
          <Alert icon={<Icon icon={faInfoCircle} />} color='blue'>
            <Text c='blue.7'>
              {t('billing_alert')}
              <Text fw={500} component='span' mx='xs'>
                {userSubscription?.plan === 'Starter'
                  ? t('starter_plan')
                  : t('ultimate_plan')}
              </Text>
              {t('billing_alert_description')}
              <Anchor
                component='button'
                onClick={() => showIntercomWithMessage('')}
                c='blue.7'
                fw={500}
                ml='xs'
                style={{ textDecoration: 'underline' }}
              >
                {t('billing_alert_button')}
              </Anchor>
            </Text>
          </Alert>
          <Flex
            justify='space-between'
            w='100%'
            gap='md'
            direction={isMobile ? 'column' : 'row'}
          >
            <BillingDetails
              userData={data}
              addressData={taxProfile?.legal_address}
            />
            <Flex direction='column' gap='md' w='100%'>
              <NextBilling
                subscription={userSubscription}
                isLoading={isLoading}
              />

              <PaymentMethod
                primary_payment_source={
                  userSubscription?.primary_payment_source ?? null
                }
              />
            </Flex>
          </Flex>
          <BillingHistory
            invoices={userSubscription?.invoices}
            plan={userSubscription?.plan}
            currentPeriod={userSubscription?.current_period_estimate}
            isLoading={isLoading}
          />
        </Flex>
      </Page.Content>
    </Page>
  )
}
